const COUPON_DURATION = Object.freeze({
    0: "Forever",
    1: "Once",
});

const COUPON_TYPES = Object.freeze({
    0: "Parameters",
    1: "Parameter and Discount",
    2: "Discount",
});

const PROMO_CODE_STATUS = Object.freeze({
    0: "Active",
    1: "Expired",
    2: "Redeemed",
});

export { COUPON_DURATION, COUPON_TYPES, PROMO_CODE_STATUS };
